module.exports = __webpack_public_path__ + "img/classify_6.b9c2e16d.png";